<script>
import CardCell from "@/components/homeRoute/CardCell.vue";
import operationDialog from "@/components/common/operationDialog.vue";
// import newCheckReport from "@/components/vision/newCheckReport.vue";
import ReportQueryDialog from "@/components/common/ReportQueryDialog.vue";

import moment from "moment";
const mapEyes = {
  finallyEyes: "双眼同时",
  finallyRight: "右眼",
  finallyLeft: "左眼"
};
export default {
  components: {
    CardCell,
    operationDialog,
    // newCheckReport,
    ReportQueryDialog
  },
  data() {
    let messData = JSON.parse(localStorage.getItem("data"));
    let histroyCheck = [];
    if (localStorage.getItem("histroyCheck")) {
      histroyCheck = JSON.parse(localStorage.getItem("histroyCheck"));
    }
    let roleDoctor =
      localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1 ||
      localStorage.getItem("roles").indexOf("ROLE_DOCTOR") > -1;
    return {
      messData,
      roleDoctor,
      hospitalList:[],
      currentHospital: {},
      currentPatient: {},
      showReportQueryDialog: false,
      searchParams: {},
      resolutionResult:
        messData && messData.DPI ? `DPI: ${messData.DPI}` : "--",
      ChallengeArr1: [
        {
          key: "VISION_CHALLENGE",
          label: "视力",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "shigongnengjiance-shili"
            },
            {
              name: "成长曲线",
              type: "path",
              route: "visionHistory"
            }
          ]
        },
        {
          key: "CONTRAST_SENSITIVITY_TRAINING",
          label: "对比敏感度",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "shigongnengjiance-duibimingandu"
            }
          ]
        },
        {
          key: "WORTH_FOUR_LAMP_HOLE_CHALLENGE",
          label: "Worth四孔灯",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "shigongnengjiance-worth4dot"
            }
          ]
        }
      ],
      ChallengeArr2: [
        {
          key: "PERCEPTUAL_EYE_POSITION",
          label: "知觉眼位",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "shigongnengjiance-zhijueyanwei"
            }
          ]
        },
        {
          key: "LINE_FUSION",
          label: "线条融合范围",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "shigongnengjiance-xiantiaoronghe"
            }
          ]
        },
        {
          key: "EXTENSIVENESS_STEREOPSIS",
          label: "大范围立体视",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "shigongnengjiance-dafanweilitishi"
            }
          ]
        }
      ],
      ChallengeArr3: [
        {
          key: "LINE_STEREOPSIS",
          label: "线条立体视锐度",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "shigongnengjiance-xiantiaolitishi"
            }
          ]
        },
        {
          key: "AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT",
          label: "弱视抑制平衡点",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "ruoshiyizhipinghengdian"
            }
          ]
        },
        {
          key: "STRABISMUS_INHIBITION_EQUILIBRIUM_POINT",
          label: "斜视抑制平衡点",
          buttons: [
            {
              name: "开始检测",
              type: "params",
              route: "xieshiyizhipinghengdian"
            }
          ]
        }
      ],
      showMultiCheck: false,
      checkList: histroyCheck,
      basicPatientInfoForm: {
        hospitalName: undefined,
        name: undefined,
        gender: undefined,
        birth: undefined,
        date: undefined,
        IPD: undefined
      },
      testResult: {
        VISION_CHALLENGE: "",
        WORTH_FOUR_LAMP_HOLE_CHALLENGE: "",
        PERCEPTUAL_EYE_POSITION: "",
        LINE_FUSION: "",
        EXTENSIVENESS_STEREOPSIS: "",
        LINE_STEREOPSIS: "",
        AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT: "",
        STRABISMUS_INHIBITION_EQUILIBRIUM_POINT: "",
        CONTRAST_SENSITIVITY_TRAINING: ""
      },
      autoChecked: '',
      // 日期选择器配置，限制只能选择今天以前的日期
      pickerOptions: {
        disabledDate(time) {
          return time > new Date(); // 只能选择今天及之前的日期
        }
      }
    };
  },
  created() {
    if (!this.roleDoctor) {
      this.loadData();
    } else {
      this.findHospital();
    }
    // 从cookie中获取医院信息
    this.getCurrentHospitalFromCookie();
  },
  watch: {
    // 监听医院列表变化，确保在使用医院列表加载后检查cookie
    hospitalList() {
      if (this.hospitalList.length > 0 && !this.currentHospital.name) {
        this.getCurrentHospitalFromCookie();
      }
    },
    // 监听currentHospital变化，同步到cookie
    currentHospital: {
      handler(newVal) {
        if (newVal && newVal.name) {
          this.setCurrentHospitalToCookie(newVal);
        }
      },
      deep: true
    }
  },
  methods: {
    authCheckedHander(val) {
       if (val === '自定义') {
          this.checkList = []
       } else if (val === '弱视') {
          this.checkList = ['CONTRAST_SENSITIVITY_TRAINING', 'WORTH_FOUR_LAMP_HOLE_CHALLENGE', 'PERCEPTUAL_EYE_POSITION', 'EXTENSIVENESS_STEREOPSIS','LINE_STEREOPSIS', 'AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT']
       } else if (val === '斜视') {
          this.checkList = ['WORTH_FOUR_LAMP_HOLE_CHALLENGE', 'WORTH_FOUR_LAMP_HOLE_CHALLENGE', 'PERCEPTUAL_EYE_POSITION', 'LINE_FUSION',  'EXTENSIVENESS_STEREOPSIS', 'LINE_STEREOPSIS']
       }
    },
    handleReportSearch(params) {
      this.searchParams = params;
    },
    toggleRepostDialog() {
      this.showReportQueryDialog = true;
    },
    async findHospital() {
      this.hospitalList = await this.$http.admin.findHospitalName();
      console.log(this.hospitalList)
    },
    // 从cookie中获取医院信息
    getCurrentHospitalFromCookie() {
      const hospitalData = this.$cookie.get('currentHospital');
      if (hospitalData) {
        try {
          const hospital = JSON.parse(hospitalData);
          this.currentHospital = hospital;
          // 如果当前有批量检查的表单，自动填入医院信息
          if (this.basicPatientInfoForm) {
            this.basicPatientInfoForm.hospitalName = hospital.name;
          }
        } catch (e) {
          console.error('解析cookie中的医院信息失败:', e);
        }
      }
    },
    // 将医院信息存入cookie
    setCurrentHospitalToCookie(hospital) {
      // 设置cookie过期时间为一年
      this.$cookie.set('currentHospital', JSON.stringify(hospital), {
        expires: 365
      });
    },
    async loadData() {
      const result = await this.$http.admin.getAllLastedTestResult();
      console.log("result", result);
      if (result && result.data) {
        result.data.forEach(o => {
          if (o.type === "VISION_CHALLENGE") {
            if (o.leftEyeVision || o.rightEyeVision) {
              this.testResult["VISION_CHALLENGE"] = `右眼：${
                o.rightEyeVision ? o.rightEyeVision.toFixed(1) : "--"
              }  左眼：${o.leftEyeVision ? o.leftEyeVision.toFixed(1) : "--"}`;
            }
          } else if (o.type === "WORTH_FOUR_LAMP_HOLE_CHALLENGE") {
            this.testResult["WORTH_FOUR_LAMP_HOLE_CHALLENGE"] = o.result.result;
          } else if (o.type === "PERCEPTUAL_EYE_POSITION") {
            const resultEyePosition =
              o.result && o.result.data ? o.result.data : o.result;
            this.testResult[
              "PERCEPTUAL_EYE_POSITION"
            ] = `算术平均：水平${resultEyePosition.jisuan.deviation_x}度，垂直${resultEyePosition.jisuan.deviation_y}度；绝对平均：水平${resultEyePosition.juedui.deviation_x}度，垂直${resultEyePosition.juedui.deviation_y}度`;
          } else if (o.type === "LINE_FUSION") {
            this.testResult["LINE_FUSION"] = `分开：${o.result.fenkai ||
              o.result.data.fenkai}度；辐辏：${o.result.fucou ||
              o.result.data.fucou}度`;
          } else if (o.type === "LINE_STEREOPSIS") {
            this.testResult["LINE_STEREOPSIS"] = o.result.result;
          } else if (o.type === "EXTENSIVENESS_STEREOPSIS") {
            this.testResult["EXTENSIVENESS_STEREOPSIS"] = o.result.result;
          } else if (o.type === "AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT") {
            this.testResult[
              "AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT"
            ] = `抑制值：${o.result.result || "--"}`;
          } else if (o.type === "STRABISMUS_INHIBITION_EQUILIBRIUM_POINT") {
            this.testResult[
              "STRABISMUS_INHIBITION_EQUILIBRIUM_POINT"
            ] = `抑制值：${o.result.result || "--"}`;
          } else if (o.type === "CONTRAST_SENSITIVITY_TRAINING") {
            const temp = o.result.data.map(o => {
              const tempName = mapEyes[o.type];
              const data = `(${o.data.map(arr => arr.join("：")).join("，")})`;
              return `${tempName}：${data}；`;
            });
            this.testResult["CONTRAST_SENSITIVITY_TRAINING"] = `${temp.join(
              "； "
            )}`;
          }
        });
      }
    },
    multiCheck() {
      if (JSON.parse(localStorage.getItem("data"))) {
        this.showMultiCheck = true;
        // 从currentHospital中获取医院信息并自动填入
        if (this.currentHospital && this.currentHospital.name) {
          this.basicPatientInfoForm.hospitalName = this.currentHospital.name;
        }
      } else {
        this.$message.warning("请先进行分辨率校准！");
      }
    },
    // 处理医院选择变化
    handleHospitalChange(hospitalName) {
      if (hospitalName) {
        this.currentHospital = {
          name: hospitalName
        };
      }
    },
    onDialogConfirm() {
      this.$refs.basicPatientInfoForm.validate(valid => {
        if (valid) {
          if (this.checkList.length >= 2) {
            localStorage.setItem(
              "histroyCheck",
              JSON.stringify(this.checkList)
            );
            this.basicPatientInfoForm.date = moment().format("YYYY-MM-DD");
            this.basicPatientInfoForm.age = moment().diff(
              this.basicPatientInfoForm.birth,
              "years"
            );
            const transData = {
              checkList: this.checkList,
              user: this.basicPatientInfoForm
            };
            const data = JSON.stringify(transData);
            sessionStorage.setItem("batchCheck", data);
            this.$router.push({
              path: `/index/batchCheck`
            });
          } else {
            this.$message.warning("请至少选择两项测试！");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<template>
  <div class="HomeRoute">
    <div class="titleView">
      <span class="line" />
      <span class="routeTitle">系统校准</span>
      <span class="line" />
    </div>
    <div class="contentView">
      <CardCell
        iconImg="resolution"
        title="分辨率校准"
        route="resolution"
        :lastedResult="resolutionResult"
      />
    </div>
    <!-- <newCheckReport style="width: 800px;margin: 0px auto;" /> -->
    <div class="titleView">
      <span class="line" />
      <span class="routeTitle">视功能检测</span>
      <span class="line" />
    </div>
    <div class="multiView" v-if="roleDoctor">
      <!-- <el-button type="primary" @click="print1">打印</el-button>
      <el-button type="primary" @click="print">下载pdf</el-button>-->
      <el-button type="primary" @click="multiCheck">批量检测</el-button>
      <el-button type="primary" @click="toggleRepostDialog">报告查询</el-button>
    </div>
    <div class="contentView">
      <CardCell
        v-for="item in ChallengeArr1"
        :key="item.key"
        :iconImg="item.key"
        :buttonArray="item.buttons"
        :title="item.label"
        :lastedResult="testResult[item.key]"
      />
    </div>
    <div class="contentView">
      <CardCell
        v-for="item in ChallengeArr2"
        :key="item.key"
        :iconImg="item.key"
        :buttonArray="item.buttons"
        :title="item.label"
        :lastedResult="testResult[item.key]"
      />
    </div>
    <div class="contentView">
      <CardCell
        v-for="item in ChallengeArr3"
        :key="item.key"
        :iconImg="item.key"
        :buttonArray="item.buttons"
        :title="item.label"
        :lastedResult="testResult[item.key]"
      />
    </div>
    <operationDialog
      :Visible="showMultiCheck"
      title="批量检测"
      class="showMultiCheckDialog"
      @confirm="onDialogConfirm"
      @close="showMultiCheck = false"
      width="412px"
    >
      <div class="showMultiCheckDialogBody">
        <el-form
          label-width="110px"
          class="showMultiCheckDialogForm"
          size="small"
          :model="basicPatientInfoForm"
          ref="basicPatientInfoForm"
        >
         <el-form-item
            label="医院："
            prop="hospitalName"
            :rules="[{ required: true, message: '请选择医院', trigger: 'blur' }]"
          >
            <el-select v-model="basicPatientInfoForm.hospitalName" clearable placeholder="医院名称" @change="handleHospitalChange">
              <el-option
                  v-for="(item,i) in hospitalList"
                  :key="i"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="姓名："
            prop="name"
            :rules="[{ required: true, message: '请输入患者姓名', trigger: 'blur' }]"
          >
            <el-input v-model="basicPatientInfoForm.name" clearable placeholder="就诊人"></el-input>
          </el-form-item>
          <el-form-item
            label="性别："
            prop="gender"
            :rules="[{ required: true, message: '请选择性别', trigger: 'blur' }]"
          >
            <el-radio-group v-model="basicPatientInfoForm.gender">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="生日："
            prop="birth"
            :rules="[{ required: true, message: '请选择生日', trigger: 'blur' }]"
          >
            <el-date-picker
              v-model="basicPatientInfoForm.birth"
              type="date"
              placeholder="选择生日"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="瞳距："
            v-if="checkList.indexOf('LINE_STEREOPSIS') > -1 || checkList.indexOf('LINE_FUSION') > -1"
            prop="IPD"
            :rules="[{ required: true, message: '请输入患者瞳距', trigger: 'blur' }]"
          >
            <el-input-number
              :controls="false"
              class="inputNumber"
              v-model="basicPatientInfoForm.IPD"
              clearable
              placeholder="瞳距"
            ></el-input-number>mm
          </el-form-item>
          <el-form-item label="检查项目：">
          <el-radio-group v-model="autoChecked" @change="authCheckedHander">
            <el-radio-button label="自定义"></el-radio-button>
            <el-radio-button label="弱视"></el-radio-button>
            <el-radio-button label="斜视"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        </el-form>

        <div>
          <el-checkbox-group v-model="checkList">
            <el-row :gutter="24">
              <!-- <el-col :span="8">
                <el-checkbox label="VISION_CHALLENGE">视力</el-checkbox>
              </el-col>-->
              <el-col :span="8">
                <el-checkbox label="CONTRAST_SENSITIVITY_TRAINING">对比敏感度</el-checkbox>
              </el-col>
              <el-col :span="8">
                <el-checkbox label="WORTH_FOUR_LAMP_HOLE_CHALLENGE">Worth四孔灯</el-checkbox>
              </el-col>
              <el-col :span="8">
                <el-checkbox label="PERCEPTUAL_EYE_POSITION">知觉眼位</el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-checkbox label="EXTENSIVENESS_STEREOPSIS">大范围立体视</el-checkbox>
              </el-col>
              <el-col :span="8">
                <el-checkbox label="LINE_STEREOPSIS">线条立体视</el-checkbox>
              </el-col>
              <el-col :span="8">
                <el-checkbox label="LINE_FUSION">线条融合</el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-checkbox label="AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT">弱视抑制平衡点</el-checkbox>
              </el-col>
              <el-col :span="8">
                <el-checkbox label="STRABISMUS_INHIBITION_EQUILIBRIUM_POINT">斜视抑制平衡点</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
      </div>
    </operationDialog>
      <ReportQueryDialog
        :visible.sync="showReportQueryDialog"
        @search="handleReportSearch"
      />
  </div>
</template>

<style lang="scss" scoped>
.HomeRoute {
  .titleView {
    // width: 100%;
    text-align: center;
    margin: 15px auto;

    .routeTitle {
      width: 8%;
      display: inline-block;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(46, 46, 46, 1);
      line-height: 25px;
      margin: 10px 20px;
    }

    .line {
      width: 42%;
      display: inline-block;
      height: 1px;
      background-color: #e4e8eb;
      margin-bottom: 5px;
    }
  }

  .contentView {
    // width: 100%;
    text-align: center;
    margin: 15px;
    display: flex;
    justify-content: center;
  }

  .multiView {
    text-align: right;
    margin: 15px;
  }
}
</style>
<style lang="scss">
.showMultiCheckDialog {
  .operationDialog .el-dialog__header {
    text-align: center;
  }

  .showMultiCheckDialogForm {
    padding: 10px 10px 15px 15px;

    .el-form-item__label {
      font-size: 16px;
      color: rgba(54, 54, 54, 1);
    }

    .el-input--small {
      width: 250px;
    }

    .el-input--small .el-input__inner {
      width: 170px;
    }
    .inputNumber {
      width: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeRoute/index.vue